import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { fetchMacroProcesses, fetchTemplatesForPurpose } from '../services/macroProcessService'
import { openModal } from '../macroProcessCreationSlice'
import { selectIfUserIsAdmin } from '../../auth/authSlice'
import { openEditModal } from '@/features/macro-process-edit/macroProcessEditSlice'
import { fetchTemplatesForEdit } from '@/features/macro-process-edit/services/macroProcessEditService'

/**
 * @typedef {Object} ProcessPurposeButtonsProps
 * @property {number} bienId
 */

const PURPOSES = [
  { key: 'location', label: 'Créer un process de location' },
  { key: 'vente', label: 'Créer un process de vente' },
]

/**
 * @param {ProcessPurposeButtonsProps} props
 */
export default function ProcessPurposeButtons({ bienId }) {
  const dispatch = useDispatch()
  const isAdmin = useSelector(selectIfUserIsAdmin)
  const existingProcesses = useSelector(state => state.macroProcessCreation.existingProcesses || [])

  // Retourne le macro process pending pour un purpose donné (pour le bouton "Ajouter des étapes")
  const getPendingProcessForPurpose = (purpose) =>
    existingProcesses.find(p => p.purpose === purpose && p.status === 'pending') || null

  useEffect(() => {
    dispatch(fetchMacroProcesses({ bien_id: bienId, status: 'pending'}))
  }, [bienId])


  return (
    <div> 
      { isAdmin && <div className="flex gap-2 mb-4 flex-wrap">
        { PURPOSES.map(({ key, label }) => {
          const pendingProcess = getPendingProcessForPurpose(key)

          if (pendingProcess) {
            return (
              <button
                key={key}
                className="btn btn-primary btn-sm"
                onClick={() => {
                  dispatch(openEditModal(pendingProcess))
                  dispatch(fetchTemplatesForEdit(key))
                }}
              >
                Ajouter des étapes ({key === 'location' ? 'Location' : 'Vente'})
              </button>
            )
          }

          return (
            <button
              key={key}
              className="btn btn-primary btn-sm"
              onClick={() => {
                dispatch(openModal(key))
                dispatch(fetchTemplatesForPurpose(key))
              }}
            >
              {label}
            </button>
          )
        })}
      </div>
     }
    </div>
  )
}
